// extracted by mini-css-extract-plugin
export default {"modal":"CertificateModal_modal__Iv3r3","enlargedCertificate":"CertificateModal_enlargedCertificate__S3YJ2"};